import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const PDWebPortalWrapper = ({ children }) => {
  useEffect(() => {
    const portalRoot = document.getElementById('pdweb-portal-root');

    if (portalRoot) {
      const style = document.createElement('style');
      style.innerHTML = `
        #pdweb-portal-root > .PDWeb_overlay {
          position: absolute;
          z-index: 1000000;
          top: 0px;
          left: 0px;
          right: 0px;
          bottom: 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.2);
        }
        #pd-web-container {
          height: 80vh;
          width: 80vw;
        }
        #pdweb-portal-root {
          position: absolute;
          z-index: 10000000000;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `;
      document.head.appendChild(style);
      return () => {
        document.head.removeChild(style);
      };
    }
  }, []);

  const portalRoot = document.getElementById('pdweb-portal-root');
  if (!portalRoot) return null;

  return ReactDOM.createPortal(children, portalRoot);
};

export default PDWebPortalWrapper;
